export const WS_CONNECT = (connIp) => ({
  type: 'WS_CONNECT',
  payload: connIp,
});

export const WS_DISCONNECT = (socket = null) => ({
  type: 'WS_DISCONNECT',
  payload: socket,
});
